module.exports = __webpack_public_path__ + "img/elife.7665d752.png";